import sizes from 'modules/application-link/domain/constants/sizes';
import useMediaQuery from 'shared/hooks/use-media-query';
import UDText from 'ud-ui/components/text';
import Layout from './layout';

interface IProps {
  text: string;
  emoji: string;
}

/**
 * Служебное сообщение на месте формы — когда показывать форму бессмысленно.
 *
 * Раньше такие случаи рендерились голым `<div>` вне `Layout`: чёрный текст на
 * белом фоне, без логотипа и фона страницы. На фоне остальной вёрстки это
 * выглядело как упавшее приложение, а не как объяснение.
 */
const ApplicationNotice = (props: IProps) => {
  const { text, emoji } = props;
  const isMobile = useMediaQuery(`(max-width: ${sizes.mobile.WIDTH}px)`);

  return (
    <Layout>
      <UDText
        id="title"
        type="title-1"
        style={{
          fontWeight: 700,
          textAlign: 'center',
          fontSize: isMobile ? 24 : 20,
          marginTop: 26,
          maxWidth: isMobile ? 309 : 630,
          lineHeight: 'unset',
        }}
        color="white"
      >
        {text}
      </UDText>
      <div
        style={{
          fontSize: '124px',
          width: 124,
          height: 124,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: isMobile ? 28 : 24,
        }}
      >
        {emoji}
      </div>
    </Layout>
  );
};

export default ApplicationNotice;
